import Mouse from "@mui/icons-material/Mouse";
import ZoomInMap from "@mui/icons-material/ZoomInMap";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

type Props = {
  visible: boolean;
};

export function ZoomOverlay({ visible }: Props) {
  if (!visible) {
    return null;
  }

  return (
    <Box
      position="absolute"
      top={-15}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      zIndex={20}
      sx={{
        backgroundColor: alpha("#000", 0.05),
        pointerEvents: "none",
      }}
    >
      <Box sx={{ mt: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Mouse
            sx={{
              fontSize: 32,
              color: "text.secondary",
            }}
          />
          <ZoomInMap
            sx={{
              color: "text.secondary",
            }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            SCROLL TO ZOOM
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}
